import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const VideoCallLimitModal = ({ isOpen, onClose, packageInfo, onUpgrade }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="text-center mb-6">
            <div className="text-6xl mb-4">⚠️</div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">{t('videoCall.limitReachedTitle')}</h2>
            <p className="text-gray-600">
              {t('videoCall.limitReachedMessage')}
            </p>
          </div>

          <div className="bg-gray-50 p-4 rounded-lg mb-6">
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm text-gray-600">{t('videoCall.package')}</span>
              <span className="font-semibold text-gray-800 capitalize">{packageInfo?.packageType || 'Free'}</span>
            </div>
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm text-gray-600">{t('videoCall.callsUsed')}</span>
              <span className="font-semibold text-red-600">{packageInfo?.callsUsed || 0}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">{t('videoCall.callsLimit')}</span>
              <span className="font-semibold text-gray-800">
                {packageInfo?.callsLimit === -1 ? t('common.unlimited') : packageInfo?.callsLimit || 0}
              </span>
            </div>
          </div>

          <div className="space-y-3">
            <h3 className="font-semibold text-gray-800 mb-2">{t('videoCall.options')}:</h3>
            
            <button
              onClick={() => {
                navigate('/marketplace/my-store?tab=settings');
                onClose();
              }}
              className="w-full p-4 bg-gradient-to-r from-green-500 to-blue-500 text-white rounded-lg hover:from-green-600 hover:to-blue-600 transition-colors text-left"
            >
              <div className="font-semibold mb-1">{t('videoCall.upgradePackage')}</div>
              <div className="text-sm opacity-90">
                {t('videoCall.premiumPackageInfo')}
              </div>
            </button>

            <button
              onClick={() => {
                navigate('/marketplace/my-store?tab=settings');
                onClose();
              }}
              className="w-full p-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors text-left"
            >
              <div className="font-semibold mb-1">{t('videoCall.buyAddon')}</div>
              <div className="text-sm opacity-90">
                {t('videoCall.addonInfo')}
              </div>
            </button>

            <button
              onClick={onClose}
              className="w-full p-4 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
              {t('videoCall.waitNextMonth')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoCallLimitModal;

